import { render, staticRenderFns } from "./FeatureFeedback.vue?vue&type=template&id=11ed9aa9&scoped=true&"
import script from "./FeatureFeedback.vue?vue&type=script&lang=js&"
export * from "./FeatureFeedback.vue?vue&type=script&lang=js&"
import style0 from "./FeatureFeedback.vue?vue&type=style&index=0&id=11ed9aa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed9aa9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
